import React from "react";

import Button from "../../pages/newLandingPage/button";
import { useAcceptCookies } from "./useAcceptCookies";
import { translate } from "react-polyglot";
import { Link } from "react-router";

import "./cookiesbar.less";


export const CookiesBar = ({ t }) => {
  const { acceptedCookies, onAcceptCookies } = useAcceptCookies();

  if (acceptedCookies) return null;

  return (
    <div className="cookies-bar">
      <div className="cookies-bar__inner-wrapper">
        <div className="cookies-bar__content">
          <div className="cookies-bar__text">
            <p>{t("landing.cookies.text")}
              {" "}
              <Link className="cookies-bar__text-link" to="/privacy-policy">{t("landing.cookies.link")}</Link>
            </p>
          </div>
          <div>
            <Button
              handleClick={onAcceptCookies}
              text={t("landing.cookies.button")}
              size="sm"
              variant="filled"
              width={"max-content"}
            />
          </div>
        </div>
      </div>
    </div>
  );
};

export default translate()(CookiesBar);



// WEBPACK FOOTER //
// ./src/js/components/widgets/cookiesbar/cookiesbar.jsx